import {District} from './District';
import {LinkedEntity} from './LinkedEntity';
import {Profile} from './Profile';
import {TeamSeason} from './TeamSeason';
import {CompetitionSeason} from './CompetitionSeason';
import {Club} from './Club';

export class Coach {
  readonly player?: Profile;
  readonly team?: TeamSeason;
  readonly links?: {
    competitions?: LinkedEntity<CompetitionSeason>[];
    teams?: LinkedEntity<TeamSeason>[];
    districts?: LinkedEntity<District>[];
    clubs?: LinkedEntity<Club>[];
  };
}
